import axios from "axios";
const qs = require("query-string");

const apiClient = axios.create({
  baseURL: global.config.main.baseUrl, // Replace with your API's base URL
  headers: {
    "Content-Type": "application/json", // Ensure JSON content type is set
  },
});

const clientCalls = axios.create({
  baseURL: global.config.main.networkProviderBaseUrl, // Replace with your API's base URL
  headers: {
    "Content-Type": " application/x-www-form-urlencoded",
  },
});

const transactionApi = axios.create({
  baseURL: global.config.main.transactionService, // Replace with your API's base URL
  headers: {
    "Content-Type": " application/x-www-form-urlencoded",
  },
});

const countryApi = axios.create({
  baseURL: global.config.main.countryService,
  headers: { "Content-Type": "application/json" },
});
const networkProviderApi = axios.create({
  baseURL: global.config.main.networkProviderService,
  headers: { "Content-Type": "application/json" },
});
const transactionHistoryApi = axios.create({
  baseURL: global.config.main.transactionHistoryService, // Replace with your API's base URL
  headers: {
    "Content-Type": " application/x-www-form-urlencoded",
  },
});

const transactionCompletionApi = axios.create({
  baseURL: global.config.main.transactionCompletionService, // Replace with your API's base URL
  headers: {
    "Content-Type": " application/x-www-form-urlencoded",
  },
});

const blackListCountryApi = axios.create({
  baseURL: global.config.main.blacklistCountryService,
  headers: {
    "Content-Type": "application/json", // Fixed headers structure
  },
});

const forexApi = axios.create({
  baseURL: global.config.main.forexService,
  headers: {
    "Content-Type": "application/json", // Fixed headers structure
  },
});

const institutionRegisteredRetryApi = axios.create({
  baseURL: global.config.main.institutionRegisteredRetryService,
  headers: {
    "Content-Type": "application/json", // Fixed headers structure
  },
});

const updateTransactionApi = axios.create({
  baseURL: global.config.main.updateTransactionService, // Replace with your API's base URL
  headers: {
    "Content-Type": " application/x-www-form-urlencoded",
  },
});
/**
 *
 * A utility function to make API requests.
 *
 * @param {string} method - The HTTP method (e.g., 'get', 'post', 'put', 'delete').
 * @param {string} url - The endpoint URL.
 * @param {object} [data] - The data to send with the request (for 'post' and 'put' methods).
 * @param {object} [params] - URL parameters (for 'get' method).
 * @returns {Promise} - A promise that resolves with the response or rejects with an error.
 */
export const makeRequest = async (method, url, data = null, params = null) => {
  try {
    const config = {
      method,
      url,
      params,
    };

    if (
      data &&
      ["get", "get", "post", "put", "delete", "patch", "patch"].includes(method)
    ) {
      config.data = data;
    }

    const response = await apiClient(config);
    return response.data;
  } catch (error) {
    console.error("API request failed:", error);
    throw error;
  }
};

// Utility function for API requests with clientCalls
export const initiateRequest = async (
  method,
  url,
  data = null,
  params = null
) => {
  try {
    const config = {
      method,
      url,
      params,
    };

    if (data && ["get", "post", "put", "delete", "patch"].includes(method)) {
      config.data = qs.stringify(data);
    } else if (data) {
      config.data = data;
    }

    const response = await clientCalls(config);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Utility function for API requests with transactionApi
export const transactionRequest = async (
  method,
  url,
  data = null,
  params = null
) => {
  try {
    const config = {
      method,
      url,
      params,
    };

    if (data && ["get", "post", "put", "delete", "patch"].includes(method)) {
      config.data = data;
    }

    const response = await transactionApi(config);
    return response.data;
  } catch (error) {
    console.error("Transaction API request failed:", error);
    throw error;
  }
};

// Utility function for API requests with countryApi
export const countryRequest = async (
  method,
  url,
  data = null,
  params = null
) => {
  try {
    const config = {
      method,
      url,
      params,
    };

    if (data && ["get", "post", "put", "delete", "patch"].includes(method)) {
      config.data = data;
    }

    const response = await countryApi(config);
    return response.data;
  } catch (error) {
    console.error("Country API request failed:", error);
    throw error;
  }
};

export const transactionHistoryRequest = async (
  method,
  url,
  data = null,
  params = null
) => {
  try {
    const config = {
      method,
      url,
      params,
    };

    if (data && ["get", "post", "put", "delete", "patch"].includes(method)) {
      config.data = data;
    }

    const response = await transactionHistoryApi(config);
    return response.data;
  } catch (error) {
    console.error("Country API request failed:", error);
    throw error;
  }
};

export const networkProviderRequest = async (
  method,
  url,
  data = null,
  params = null
) => {
  try {
    const config = {
      method,
      url,
      params,
    };

    if (data && ["get", "post", "put", "delete", "patch"].includes(method)) {
      config.data = data;
    }

    const response = await networkProviderApi(config);
    return response.data;
  } catch (error) {
    console.error("Country API request failed:", error);
    throw error;
  }
};

export const transactionCompletionRequest = async (
  method,
  url,
  data = null,
  params = null
) => {
  try {
    const config = {
      method,
      url,
      params,
    };

    if (data && ["get", "post", "put", "delete", "patch"].includes(method)) {
      config.data = data;
    }

    const response = await transactionCompletionApi(config);
    return response.data;
  } catch (error) {
    console.error("Country API request failed:", error);
    throw error;
  }
};

export const blackListCountryRequest = async (
  method,
  url,
  data = null,
  params = null
) => {
  try {
    const config = {
      method,
      url,
      params,
      headers: {
        "Content-Type": "application/json", // Ensure headers are sent
      },
    };

    if (data) {
      config.data = data;
    }

    const response = await blackListCountryApi(config);
    return response.data;
  } catch (error) {
    console.error("Blacklist Country API request failed:", error);
    throw error;
  }
};

export const forexRequest = async (method, url, data = null, params = null) => {
  try {
    const config = {
      method,
      url,
      params,
      headers: {
        "Content-Type": "application/json",
      },
    };

    if (data) {
      config.data = data;
    }

    const response = await forexApi(config);
    return response.data;
  } catch (error) {
    console.error("forex API request failed:", error);
    throw error;
  }
};

export const institutionRegisteredRetryRequest = async (
  method,
  url,
  data = null,
  params = null
) => {
  try {
    const config = {
      method,
      url,
      params,
      headers: {
        "Content-Type": "application/json",
      },
    };

    if (data) {
      config.data = data;
    }

    const response = await institutionRegisteredRetryApi(config);
    return response.data;
  } catch (error) {
    console.error("institutionRegisteredRetry API request failed:", error);
    throw error;
  }
};

export const updateTransactionRequest = async (
  method,
  url,
  data = null,
  params = null
) => {
  try {
    const config = {
      method,
      url,
      params,
      headers: {
    "Content-Type": " application/x-www-form-urlencoded",
      },
    };

    if (data) {
      config.data = data;
    }

    const response = await updateTransactionApi(config);
    return response.data;
  } catch (error) {
    console.error("updateTransaction API request failed:", error);
    throw error;
  }
};
